// extracted by mini-css-extract-plugin
module.exports = {"Container":"FocusInputs_Container__gsv74","CurrentTimeLabel":"FocusInputs_CurrentTimeLabel__VDDdu","DurationLabel":"FocusInputs_DurationLabel__DJSBu"};